export default {"src":"/assets/turbo/0eee2b9c/quellede/_next/static/media/favicon.5306d79d.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};